import React, { useEffect, useState } from 'react';
import { User, Plus } from 'lucide-react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../../api';

export default function EmployeesList() {
  const [employees, setEmployees] = useState([]);
  const [search, setSearch] = useState('');
  const [roleFilter, setRoleFilter] = useState('');
  const [error, setError] = useState(null);
  const [organisationId, setOrganisationId] = useState(null);

      useEffect(() => {
      const fetchUser = async () => {
        try {
          const userResponse = await api.get('/me', { withCredentials: true });
          if (!userResponse.data.success) {
            console.error('Impossible de récupérer les informations utilisateur.');
            return;
          }
  
          const user = userResponse.data.user;
          console.log(user);
          setOrganisationId(parseInt(user.organisation_id, 10));
  
        } catch (error) {
          console.error('Erreur lors de la récupération des informations utilisateur.');
        }
      };
  
      fetchUser();
    }, []);

useEffect(() => {
  const fetchEmployees = async () => {
      if (!organisationId) return;

    if (!organisationId) {
      setError("Organisation non définie ");
      return;
    }

    try {
      // On utilise l'instance API → pas besoin de répéter l'URL complète
      const { data } = await api.get("/utilisateurs");

      if (data.utilisateurs) {
        // On filtre les employés pour ne garder que ceux de la bonne organisation
        const filteredEmployees = data.utilisateurs.filter(
          (employee) => employee.organisation_id === parseInt(organisationId)
        );
        setEmployees(filteredEmployees);
      } else {
        setError("Données inattendues");
        console.error("Réponse inattendue:", data);
      }
    } catch (err) {
      console.error("Erreur lors du chargement des employés:", err);
      setError("Impossible de charger les employés");
      toast.error("Impossible de charger les employés");
    }
  };

  fetchEmployees();
}, [organisationId]);



  // Extraire les noms de rôle uniques pour le filtre
  const uniqueRoles = [...new Set(employees.map((e) => e.role.nom))];

  // Filtrer les employés selon la recherche et le rôle sélectionné
  const filteredEmployees = employees.filter((emp) => {
    const matchesName = `${emp.nom} ${emp.prenom}`
      .toLowerCase()
      .includes(search.toLowerCase());
    const matchesRole = roleFilter
      ? emp.role.nom === roleFilter
      : true;
    return matchesName && matchesRole;
  });

  return (
    <section className="bg-white rounded-2xl shadow-inner p-6 w-full">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6 gap-4">
        <h2 className="text-2xl font-bold text-terrecuite">Utilisateurs</h2>
        <div className="flex flex-wrap items-center gap-3">
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Rechercher par nom..."
            className="border rounded-lg px-3 py-2 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-terrecuite"
          />
          <select
            value={roleFilter}
            onChange={(e) => setRoleFilter(e.target.value)}
            className="border rounded-lg px-3 py-2 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-terrecuite"
          >
            <option value="">Tous les rôles</option>
            {uniqueRoles.map((roleName) => (
              <option key={roleName} value={roleName}>
                {roleName}
              </option>
            ))}
          </select>
          <Link
            to="/admin-client/add-employee"
            className="flex items-center gap-2 bg-terrecuite text-white px-4 py-2 rounded-lg hover:bg-[#a55f50] transition-colors text-sm"
          >
            <Plus className="w-4 h-4" /> Ajouter
          </Link>
        </div>
      </div>

      {error && <p className="text-red-500">{error}</p>}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {filteredEmployees.map((emp) => (
          <Link
            key={emp.utilisateur_id}
            to={`/admin-client/employees/${emp.utilisateur_id}`}
            className="group flex flex-col bg-white rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300 p-5"
          >
<div className="flex items-center mb-4">
  {emp.photo ? (
    <img
      src={emp.photo.startsWith('http') ? emp.photo : `http://127.0.0.1:8000/storage/${emp.photo}`}
      alt={`${emp.nom} ${emp.prenom}`}
      className="w-12 h-12 object-cover rounded-full border-2 border-terrecuite shadow-sm"
    />
  ) : (
    <div className="w-12 h-12 flex items-center justify-center bg-[#f4e2de] rounded-full">
      <User className="w-6 h-6 text-terrecuite" />
    </div>
  )}
  <h3 className="ml-4 text-lg font-semibold text-gray-900 group-hover:text-terrecuite transition-colors duration-300">
    {emp.nom} {emp.prenom}
  </h3>
</div>

            <p className="text-gray-600 mb-2">
              <strong className="text-terrecuite">Rôle:</strong> {emp.role.nom}
            </p>
            <p className="text-gray-600 mb-2 truncate">
              <strong className="text-terrecuite">Email:</strong> {emp.email}
            </p>
            <p className="text-gray-600 mb-4">
              <strong className="text-terrecuite">Téléphone:</strong> {emp.telephone || 'N/A'}
            </p>
            <span className="mt-auto inline-block text-terrecuite font-medium group-hover:underline">
              Voir détails →
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}
